import Spinner from "components/base/Spinner";
import localforage from "localforage";
import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { ProductContext } from "./context";
import Products from "./Products";
import ReleaseDetailPage from "./ReleaseDetailPage";

const ProductReleasePages = () => {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);

  useEffect(async () => {
    try {
      const value = await localforage.getItem("products");
      setProducts(value || []);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    localforage.setItem("products", products).catch((err) => {
      console.error("Error saving products to localforage:", err);
    });
  }, [products]);

  console.log("products", products);

  if (loading) return <Spinner />;

  return (
    <ProductContext.Provider value={{ products, setProducts }}>
      <Routes>
        <Route>
          <Route index element={<Products />} />
          <Route path=":id" element={<ReleaseDetailPage />} />
        </Route>
      </Routes>
    </ProductContext.Provider>
  );
};

export default ProductReleasePages;
